<h2 mat-dialog-title>Adicionales para {{data.item}}</h2>
<mat-dialog-content>
  <br>
  <ul>
    <li *ngFor="let optional of allOptionals">
      <mat-checkbox [(ngModel)]="optional.checked">
        {{optional.dsName}}
      </mat-checkbox>
    </li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
  <button mat-button class="btnSaveChanges" (click)="saveChanges()">Guardar cambios</button>
</mat-dialog-actions>